"use client";

import { NextIntlClientProvider, IntlErrorCode } from "next-intl";
import type { AbstractIntlMessages } from "next-intl";

function onError(error: { code: string }) {
  if (error.code !== IntlErrorCode.MISSING_MESSAGE) {
    console.error(error);
  }
}

function getMessageFallback({ key }: { key: string }) {
  return key;
}

export default function IntlProvider({
  messages,
  locale,
  children,
}: {
  messages: AbstractIntlMessages;
  locale: string;
  children: React.ReactNode;
}) {
  return (
    <NextIntlClientProvider
      messages={messages}
      locale={locale}
      onError={onError}
      getMessageFallback={getMessageFallback}
    >
      {children}
    </NextIntlClientProvider>
  );
}
